import { RevertOutlineIcon } from '@carboncopyco/icons';
import { useDropdownOnOpenChange } from '../useOnDropdownOpenChange';
import { RowOptions } from './RowOptions';
import { RowOptionsItem } from './RowOptionsItem';

type RowOptionsTdProps = {
  row: { id_value: string };
  isRowSelected: boolean;
  isRowModified: boolean;
  onSelectedRowChange: (rowId: string | undefined) => void;
  onRevert: ({
    entity,
    row_id,
    col_name,
  }: {
    entity: 'cell' | 'column' | 'row';
    row_id?: string;
    col_name?: string;
  }) => void;
};

export const RowOptionsTd = ({
  row,
  isRowSelected,
  isRowModified,
  onSelectedRowChange,
  onRevert,
}: RowOptionsTdProps) => {
  const { onOpenChange } = useDropdownOnOpenChange(onSelectedRowChange);

  return (
    <td className="border-t border-l border-solid border-ds-natural-150 p-0 relative w-[34px] min-w-[34px]">
      <RowOptions
        isModified={isRowModified}
        onOpenChange={(isOpen) => {
          onOpenChange(isOpen, row.id_value);
        }}
      >
        <RowOptionsItem
          label="Revert edits"
          iconLeft={<RevertOutlineIcon size={16} />}
          onClick={() => {
            onRevert({
              entity: 'row',
              row_id: row.id_value,
            });
          }}
          disabled={!isRowModified}
        />
      </RowOptions>
      {isRowSelected && (
        <div className="absolute inset-0 border-ds-primary-300 border-solid border-l border-y pointer-events-none" />
      )}
    </td>
  );
};
